<!-- *** Michal added new page UserAdd.vue -->
<template>
  <div>
    <LTSHeader></LTSHeader>
    <div class="container">
      <div v-if="error" class="card">
        <div class="card-header bg-danger text-white text-bold text-center">{{ error }}</div>
      </div>
      <div class="header-section">
        <div class="text-bold">Administrator: User Add</div>
        <div class="back-btn">
          <router-link class="btn-sm bg-primary text-white text-bold" to="/usersearch">
            <img src="../assets/arrow-left.svg" alt /> Back
          </router-link>
        </div>
      </div>
      <div class="filters-section">
        <div class="row mb-1">
          <div class="col mr-1">
            <label for="ltsuserid">LTS User Id</label>
            <input v-model="ltsuserid" type="text" readonly="true" class="textbox" id="ltsuserid" name="ltsuserid" />
          </div>
          <div class="col">
            <label for="ltsuserid">LTS App Id</label>
            <input v-model="ltsappid" type="text" readonly="true" class="textbox" id="ltsappid" name="ltsappid" />
          </div>
        </div>
        <div class="row mb-1">
          <div class="col mr-1">
            <label for="username">Username</label>
            <input v-model="username" type="text" class="textbox" id="username" name="username" />
            <small v-show="username_invalid" class="required">Please enter a username</small>
          </div>
          <div class="col">
            <label for="password">Password</label>
            <input v-model="password" type="text" class="textbox" id="password" name="password" />
            <small v-show="password_invalid" class="required">Please enter a password</small>
            <small v-show="password_incor" class="required">Invalid Password</small>
          </div>
        </div>
        <div class="row mb-1">
          <div class="col mr-1">
            <label for="name">Name</label>
            <input v-model="name" type="text" class="textbox" id="name" name="name" />
            <small v-show="name_invalid" class="required">Please enter a name</small>
          </div>
          <div class="col">
            <label for="surname">Surname</label>
            <input v-model="surname" type="text" class="textbox" id="surname" name="surname" />
            <small v-show="surname_invalid" class="required">Please enter a surname</small>
          </div>
        </div>
        <div class="row mb-1">
          <div class="col mr-1">
            <label for="email">Email</label>
            <input v-model="email" type="text" class="textbox" id="email" name="email" />
            <small v-show="email_invalid" class="required">Please enter a email</small>
            <small v-show="email_incor" class="required">Invalid Email</small>
          </div>
          <div class="col">
              &nbsp;
          </div>
        </div>
        <div class="row mb-1">
          <div class="col">
            <div class="search-button">
              <button @click.prevent="UserAdd" class="btn bg-primary text-white mr-2">Add</button>
              <button @click.prevent="CancelAdd" class="btn bg-primary text-white mr-2">Cancel</button>
            </div>
          </div>
        </div>
      </div>
      <Loader v-show="isAdding" class="loader"></Loader>
    </div>
  </div>
</template>

<script>
import LTSHeader from "@/components/LTSHeader";
import Loader from "@/components/Loader.vue";
import axios from "axios";

export default {
  components: {
    LTSHeader,
    Loader
  },

  data: function() {
    return {
        isSearching: false,
        hasSearched: false,
        userAccountId: "",
        isAdding: false,
        ltsuserid: "",
        ltsappid: "",
        username: "",
        password: "",
        name: "",
        surname: "",
        email: "",
        username_invalid: false,
        password_invalid: false,
        name_invalid: false,
        surname_invalid: false,
        email_invalid: false,
        error: ""
    };
  },
  mounted() {
    this.ltsuserid = this.$route.query.ID.toString();
    this.ltsappid = this.$route.query.APPID.toString();
    if ((this.ltsuserid != "0") && (this.ltsappid != "0"))
    {
      this.UserLoad();
    }
  },
  methods: {
    UserLoad: function() {
      axios
        .post("/useradd/getinfo", {
          ltsuserid: this.ltsuserid,
          ltsappid: this.ltsappid
        })
        .then(response => {
          this.name = response.data.name;
          this.surname = response.data.surname;
          this.email = response.data.email;
          this.username = response.data.username;
          this.password = response.data.password;
        })
        .catch(err => {
          this.error =
            "Could not unlink the user profile. Please contact technical support.";
          console.log(err.response);
        });
    },

    UserAdd: function() {
        this.error = "";
        this.isAdding = true;

        // Validation
        this.username.trim().length > 0
        ? (this.username_invalid = false)
        : (this.username_invalid = true);

        this.password.trim().length > 0
        ? (this.password_invalid = false)
        : (this.password_invalid = true);

        this.name.trim().length > 0
        ? (this.name_invalid = false)
        : (this.name_invalid = true);

        this.surname.trim().length > 0
        ? (this.surname_invalid = false)
        : (this.surname_invalid = true);

        this.email.trim().length > 0
        ? (this.email_invalid = false)
        : (this.email_invalid = true);

        if (this.username_invalid || this.password_invalid || this.name_invalid || this.surname_invalid || this.email_invalid) {
        this.isAdding = false;
        this.error = "Could not add user. Please complete all required fields.";
        return;
        }

        axios
        .post("/useradd", {
            ltsuserid: this.ltsuserid,
            ltsappid: this.ltsappid,
            username: this.username,
            password: this.password,
            name: this.name,
            surname: this.surname,
            email: this.email
        })
        .then(response => {
            this.$router.push({ path: '/useredit', query: { ID: response.data } })
            //console.log(response.data.userId);
        })
        .catch(err => {
            if (err.response.status == 400)
            {
              if(err.response.data != "")
              {
                 if(err.response.data.includes("Password"))
                {
                  this.password_incor = true;
                }
                else{
                  this.password_incor = false;
                }

                if(err.response.data.includes("Email"))
                {
                  this.email_incor = true;
                }
                else{
                  this.email_incor = false;
                }
                this.error = err.response.data;

               
              }
              else{
              this.error =
                "Could not add user, user already exists.";
              }
            }
            else
            {
              this.error =
                "Internal System Exception. Please contact technical support.";

            }
            //console.log(err.response);
        })
        .finally(() => {
          this.isAdding = false;
        });
    },

    CancelAdd: function() {
        this.$router.push("/usersearch");
    },
  }
}
</script>

<style lang="scss" scoped>
/* IMPORT VARIABLES */
@import "@/styles/_variables.scss";

.header-section {
  display: flex;
  justify-content: space-between;
  background: #f8f8ff;
  border: 1px solid $grey-color;
  padding: 0.5rem;
}

.back-btn {
  margin-left: auto;

  a {
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;

    img {
      padding-right: 5px;
    }
  }
}

.search-button {
  display: flex;
  justify-content: flex-end;
  padding: 5px;
  margin-bottom: 0 !important;
}

.filters-section {
  display: flex;
  flex-direction: column;
  background: #f8f8ff;
  border: 1px solid $grey-color;
  padding: 0.5rem;
}

.required {
  display: block;
  color: $danger-color;
}
</style>